import { request } from '@wix/da-shared-react/pkg/xhr';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import { pinPostOnFeed } from '../actions/feed';
import { updateModule } from '../actions/modules';
import { API_BASE_PATH } from '../../constants';
import { ModuleType } from '../../types/modules';
import { getModuleIdByModuleType } from '../selectors/modules';

function* postRequest(methodName, data = {}) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/feed_pinned_deviation/${methodName}`,
    data,
  });
}

export function* pinPostOnFeedSaga(action) {
  const {
    payload: { item },
  } = action;

  let result;
  if (item !== undefined) {
    result = yield call(postRequest, 'pin', {
      itemid: item.deviationId,
      typeid: item.typeId,
    });
  } else {
    result = yield call(postRequest, 'unpin');
  }

  const moduleId = yield select(
    getModuleIdByModuleType,
    ModuleType.FEED_PINNED_DEVIATION
  );

  if (result && result.success) {
    yield put(
      updateModule({
        id: moduleId,
        moduleData: {
          itemId: item && item.deviationId,
          typeId: item && item.typeId,
        },
      })
    );
    return;
  }
}

export default function* rootFeedSaga() {
  yield all([takeLatest(pinPostOnFeed, pinPostOnFeedSaga)]);
}
